import 'twin.macro';
import React from 'react';
import qs from 'qs';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { reasonsToCancel, ReasonType } from './reasonsToCancel';
import Textarea from '@teetsh/app/src/components/Form/Textarea';
import useCancelSubscription from '@teetsh/app/src/containers/UserSettings/Souscription/useCancelSubscription';
import { Field, Form } from 'react-final-form';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import subscriptionUrl from '@teetsh/app/src/containers/UserSettings/Souscription/urls';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

type TitleKey =
  | 'missingFeaturesDetails'
  | 'missingContentDetails'
  | 'otherTool2Details'
  | 'otherDetails';

function getDetailsTitleKey(reason: ReasonType): TitleKey {
  switch (reason) {
    case 'missingFeatures':
      return 'missingFeaturesDetails';
    case 'missingContent':
      return 'missingContentDetails';
    case 'otherTool2':
      return 'otherTool2Details';
    default:
      return 'otherDetails';
  }
}

export function Details() {
  const user = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);
  const { required } = useTranslatedValidation();
  const location = useLocation();
  const cancelSubscription = useCancelSubscription();
  const onClose = () => navigate(subscriptionUrl.subscription);
  const params = qs.parse(location.search.substr(1));
  const matchingReason = reasonsToCancel.find(r => r.value === params.reason);
  if (!matchingReason || !matchingReason.hasDetails) {
    navigate(subscriptionUrl.reason());
    return null;
  }
  const detailsTitleKey = getDetailsTitleKey(matchingReason.value);

  return (
    <Form<{ detail: string }>
      initialValues={{ detail: '' }}
      onSubmit={async v => {
        await cancelSubscription({
          cancelReason: matchingReason?.value as any,
          cancelReasonDetails: v.detail,
          otherToolDetail: params.otherToolDetail,
        }).then(() =>
          navigate(
            `${subscriptionUrl.recap()}?previousPlan=${user.currentPlan}`,
          ),
        );
      }}
    >
      {({ handleSubmit, submitting, valid }) => (
        <SimpleModal
          isOpen
          isLoading={submitting}
          closeModalFct={() => onClose()}
          validateTitle={t(
            'userSettings:subscription.cancel.featureWarningModal.confirmCancel',
          )}
          disabled={!valid}
          validateAction={() => handleSubmit()}
        >
          <div tw="p-8">
            <H2 tw="mb-8">
              {t(`subscription.cancel.reasons.${detailsTitleKey}`)}
            </H2>
            <Field
              name="detail"
              validate={required}
              render={({ input: { value, onChange } }) => (
                <Textarea
                  minimal={false}
                  autoFocus
                  value={value}
                  onChange={e => onChange(e.target.value)}
                  minRows={5}
                />
              )}
            />
          </div>
        </SimpleModal>
      )}
    </Form>
  );
}
